import { render, staticRenderFns } from "./PicklHistory.vue?vue&type=template&id=a5d0f2ea&scoped=true&"
import script from "./PicklHistory.vue?vue&type=script&lang=ts&"
export * from "./PicklHistory.vue?vue&type=script&lang=ts&"
import style0 from "./PicklHistory.vue?vue&type=style&index=0&id=a5d0f2ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d0f2ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5d0f2ea')) {
      api.createRecord('a5d0f2ea', component.options)
    } else {
      api.reload('a5d0f2ea', component.options)
    }
    module.hot.accept("./PicklHistory.vue?vue&type=template&id=a5d0f2ea&scoped=true&", function () {
      api.rerender('a5d0f2ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/PicklHistory.vue"
export default component.exports